<app-page-section sectionClass="page-offset section-pad about-page" containerClass="container">
  <div class="row justify-content-center">
    <div class="col-lg-10 col-xl-9">
      <div class="soft-card bg-white p-4 p-md-5 mb-4 about-hero">
        <span class="badge rounded-pill text-bg-primary mb-3">{{ i18n.t('about.badge') }}</span>
        <h1 class="display-5 fw-bold mb-3">{{ i18n.t('about.title') }}</h1>
        <p class="lead text-secondary mb-4">{{ i18n.t('about.subtitle') }}</p>
        <div class="d-flex flex-column flex-sm-row gap-3">
          <a routerLink="/signup" class="btn btn-primary btn-lg"><i class="bi bi-person-plus me-2"></i>{{ i18n.t('about.primaryCta') }}</a>
          <a routerLink="/contact" class="btn btn-outline-primary btn-lg"><i class="bi bi-chat-dots me-2"></i>{{ i18n.t('about.secondaryCta') }}</a>
          <a href="https://www.linkedin.com/in/jean-baptiste-beck/" target="_blank" rel="noopener noreferrer" class="btn btn-outline-secondary btn-lg"><i class="bi bi-linkedin me-2"></i>{{ i18n.t('about.linkedinCta') }}</a>
          <a href="https://buymeacoffee.com/champagnearden" target="_blank" rel="noopener noreferrer" class="btn btn-outline-secondary btn-lg"><i class="bi bi-cup-hot me-2"></i>{{ i18n.t('about.buyMeCoffeeCta') }}</a>
        </div>
      </div>

      <div class="row g-4 mb-4">
        <div class="col-md-6">
          <section class="soft-card bg-white h-100 p-4">
            <i class="bi bi-person-workspace fs-2 text-primary" aria-hidden="true"></i>
            <h2 class="h4 mt-3">{{ i18n.t('about.teamTitle') }}</h2>
            <p class="text-secondary mb-0">{{ i18n.t('about.teamText') }}</p>
            <p class="about-ai-note mt-3 mb-0"><i class="bi bi-stars me-1" aria-hidden="true"></i>{{ i18n.t('about.aiAssistanceNote') }}</p>
          </section>
        </div>
        <div class="col-md-6">
          <section class="soft-card bg-white h-100 p-4">
            <i class="bi bi-bullseye fs-2 text-primary" aria-hidden="true"></i>
            <h2 class="h4 mt-3">{{ i18n.t('about.objectivesTitle') }}</h2>
            <p class="text-secondary mb-0">{{ i18n.t('about.objectivesText') }}</p>
          </section>
        </div>
      </div>

      <section class="soft-card bg-white p-4 p-md-5 mb-4">
        <h2 class="h3 fw-bold mb-3">{{ i18n.t('about.valuesTitle') }}</h2>
        <div class="row g-3">
          <div class="col-md-4"><div class="about-value p-3 h-100"><strong>{{ i18n.t('about.valueFocusTitle') }}</strong><p class="text-secondary mb-0">{{ i18n.t('about.valueFocusText') }}</p></div></div>
          <div class="col-md-4"><div class="about-value p-3 h-100"><strong>{{ i18n.t('about.valuePrivacyTitle') }}</strong><p class="text-secondary mb-0">{{ i18n.t('about.valuePrivacyText') }}</p></div></div>
          <div class="col-md-4"><div class="about-value p-3 h-100"><strong>{{ i18n.t('about.valueImpactTitle') }}</strong><p class="text-secondary mb-0">{{ i18n.t('about.valueImpactText') }}</p></div></div>
        </div>
      </section>

      <section class="soft-card bg-white p-4 p-md-5 about-sustainability" aria-live="polite">
        <div class="d-flex flex-column flex-lg-row justify-content-between gap-4">
          <div>
            <p class="text-uppercase text-primary fw-semibold small mb-2">{{ i18n.t('about.sustainability.eyebrow') }}</p>
            <h2 class="h3 fw-bold mb-3">{{ i18n.t('about.sustainability.title') }}</h2>
            <p class="text-secondary mb-0">{{ i18n.t('about.sustainability.description') }}</p>
          </div>
          <div class="about-sustainability-card p-4">
            @if (isLoadingSustainability()) {
              <span class="text-secondary">{{ i18n.t('about.sustainability.loading') }}</span>
            } @else if (sustainabilityLoadFailed()) {
              <span class="text-secondary">{{ i18n.t('about.sustainability.loadFailed') }}</span>
            } @else {
              <span class="about-metric-label">{{ i18n.t('about.sustainability.totalLabel') }}</span>
              <strong class="about-metric-value">{{ formatKg(sustainabilityMetric()?.yearlyKgCO2e ?? sustainabilityMetric()?.totalKgCO2e) }}</strong>
              <span class="about-metric-detail">{{ sustainabilityMetric()?.periodLabel ?? i18n.t('about.sustainability.defaultPeriod') }}</span>
              @if (sustainabilityMetric()?.status === 'unavailable') {
                <span class="about-metric-detail text-secondary">{{ i18n.t('about.sustainability.pending') }}</span>
              }
            }
          </div>
        </div>
      </section>
    </div>
  </div>
</app-page-section>